import './ContactsPage.css';
import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/FacebookOutlined';
import { trackEmail, trackSocialMedia } from '../common/utils/analytics';
import SEO from '../common/components/seo/SEO';
import { getBreadcrumbStructuredData } from '../common/utils/structuredData';

// Bluesky SVG Icon Component (official logo)
const BlueskyIcon = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
    >
        <g fill="none">
            <path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"/>
            <path fill="currentColor" d="M5.892 2.93c-1.78-1.06-3.813.446-3.63 2.359l.398 4.185c.176 1.855 1.84 4.026 4.195 3.823C4.5 14 3.132 15.865 4.88 18.145c.286.373.597.745.914 1.062s.69.628 1.062.914c1.88 1.441 4.375-.65 5.055-2.69l.09-.268l.09.269c.68 2.04 3.174 4.13 5.055 2.689c.372-.286.745-.597 1.062-.914s.628-.69.914-1.062c1.747-2.28.379-4.145-1.976-4.848c2.355.203 4.018-1.968 4.195-3.823l.399-4.185c.182-1.913-1.852-3.418-3.631-2.36C15.2 4.66 13.485 7.393 12 9.902C10.515 7.392 8.8 4.66 5.892 2.93"/>
        </g>
    </svg>
);

function ContactsPage() {
    const contactItems = [
        {
            id: 'email',
            icon: <EmailIcon />,
            label: 'Email',
            value: 'me@valeter.net',
            href: 'mailto:me@valeter.net',
            onClick: trackEmail,
            type: 'email'
        },
        {
            id: 'instagram',
            icon: <InstagramIcon />,
            label: 'Instagram',
            value: '@ValeTer_',
            href: 'https://www.instagram.com/ValeTer_',
            onClick: () => trackSocialMedia('Instagram'),
            type: 'social'
        },
        {
            id: 'facebook',
            icon: <FacebookIcon />,
            label: 'Facebook',
            value: 'ValeTerPhotography',
            href: 'https://www.facebook.com/ValeTerPhotography',
            onClick: () => trackSocialMedia('Facebook'),
            type: 'social'
        },
        {
            id: 'bluesky',
            icon: <BlueskyIcon className="bluesky-icon" />,
            label: 'Bluesky',
            value: '@valeter.bsky.social',
            href: 'https://bsky.app/profile/valeter.bsky.social',
            onClick: () => trackSocialMedia('Bluesky'),
            type: 'social'
        }
    ];

    const breadcrumbData = getBreadcrumbStructuredData([
        { name: 'Home', url: '/' },
        { name: 'Contact', url: '/contacts' },
    ]);

    return (
        <>
            <SEO
                title="Contact - Get In Touch"
                description="Get in touch with ValeTer (Valerii Tereshchenko) for landscape photography prints, collaborations, or inquiries. Connect via email, Instagram, Facebook, or Bluesky."
                keywords="contact photographer, landscape photography prints, photography collaboration, photographer contact, ValeTer contact"
                structuredData={breadcrumbData}
            />
            <Paper className='contacts-page'>
                <Box className="contacts-header">
                <Typography variant="h3" component="h1" className="contacts-title">
                    Get In Touch
                </Typography>
                <Typography variant="body1" className="contacts-subtitle">
                    Feel free to reach out for collaborations, prints, or just to say hello!
                </Typography>
            </Box>

            <Box className="contacts-grid">
                {contactItems.map((item) => (
                    <Card 
                        key={item.id} 
                        className={`contact-card contact-card-${item.type}`}
                        component="a"
                        href={item.href}
                        target={item.type === 'social' ? '_blank' : undefined}
                        rel={item.type === 'social' ? 'noopener noreferrer' : undefined}
                        onClick={item.onClick}
                    >
                        <CardContent className="contact-card-content">
                            <Box className="contact-icon-wrapper">
                                {item.icon}
                            </Box>
                            <Typography variant="h6" component="div" className="contact-label">
                                {item.label}
                            </Typography>
                            <Typography variant="body2" className="contact-value">
                                {item.value}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}
            </Box>
        </Paper>
        </>
    );
}

export default ContactsPage;
